// ─────────────────────────────────────────────
// Delete Button (shared)
// ─────────────────────────────────────────────
export function DeleteBtn({ onDelete }) {
  return (
    <button
      onClick={onDelete}
      title="Remove block"
      style={{
        position: "absolute",
        top: 8,
        right: 8,
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: "none",
        background: "rgba(255,255,255,0.92)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
        zIndex: 10,
        transition: "background 0.15s",
        padding: 0,
      }}
      onMouseEnter={e => (e.currentTarget.style.background = "#ffe0e0")}
      onMouseLeave={e => (e.currentTarget.style.background = "rgba(255,255,255,0.92)")}
    >
      {/* Trash / X icon in red */}
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M2 2L12 12M12 2L2 12" stroke="#e53e3e" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    </button>
  );
}


export function PlayPauseBtn({ isPlaying, onClick }) {
  return (
    <button
      onClick={onClick}
      title={isPlaying ? "Pause" : "Play"}
      style={{
        position: "absolute",
        top: 8,
        right: 44, // sits left of the delete button (which is at right:8, width:28)
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: "none",
        background: "rgba(255,255,255,0.92)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
        zIndex: 10,
        transition: "background 0.15s",
        padding: 0,
      }}
      onMouseEnter={e => (e.currentTarget.style.background = "#e0f0ff")}
      onMouseLeave={e => (e.currentTarget.style.background = "rgba(255,255,255,0.92)")}
    >
      {isPlaying ? (
        // Pause icon — two vertical bars
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none">
          <rect x="1"   y="1" width="3.5" height="12" rx="1" fill="#1a73e8" />
          <rect x="7.5" y="1" width="3.5" height="12" rx="1" fill="#1a73e8" />
        </svg>
      ) : (
        // Play icon — right-pointing triangle
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none">
          <path d="M2 1.5L11 7L2 12.5V1.5Z" fill="#1a73e8" />
        </svg>
      )}
    </button>
  );
}